if (!customElements.get('product-modal')) {
  customElements.define('product-modal', class ProductModal extends ModalDialog {
    constructor() {
      super();
      this.addEventListener('click', event => {
        const step = event.target.closest('[data-modal-step]');
        if (step) this.select(this.index + Number(step.dataset.modalStep));
        if (event.target.closest('[data-modal-zoom]') || event.target.matches('img.active')) this.zoom();
      });
      this.addEventListener('keydown', event => {
        if (!['ArrowLeft','ArrowRight'].includes(event.key) || event.target.closest('video,iframe,model-viewer')) return;
        event.preventDefault();
        this.select(this.index + (event.key === 'ArrowRight' ? 1 : -1));
      });
    }
    show(opener) {
      super.show(opener);
      this.items = [...this.querySelectorAll('.product-media-modal__content > [data-media-id]')];
      this.select(Math.max(0, this.items.findIndex(item => item.dataset.mediaId === opener.dataset.mediaId)));
    }
    select(index) {
      if (!this.items?.length) return;
      window.pauseAllMedia();
      this.index = (index + this.items.length) % this.items.length;
      this.classList.remove('is-zoomed');
      this.items.forEach((item, i) => item.classList.toggle('active', i === this.index));
      const active = this.items[this.index];
      const content = this.querySelector('[role="document"]');
      content.scrollTo(0, 0);
      const counter = this.querySelector('[data-modal-count]');
      if (counter) counter.textContent = `${this.index + 1} / ${this.items.length}`;
      this.querySelectorAll('[data-modal-step]').forEach(button => button.disabled = this.items.length < 2);
      const zoom = this.querySelector('[data-modal-zoom]');
      if (zoom) {
        zoom.disabled = active.tagName !== 'IMG';
        zoom.setAttribute('aria-pressed', 'false');
        zoom.textContent = '+';
      }
      if (active.tagName === 'IMG') active.loading = 'eager';
      else (active.matches('deferred-media,product-model') ? active : active.querySelector('deferred-media,product-model'))?.loadContent?.();
    }
    zoom() {
      if (this.items?.[this.index]?.tagName !== 'IMG') return;
      const zoomed = this.classList.toggle('is-zoomed');
      const button = this.querySelector('[data-modal-zoom]');
      button?.setAttribute('aria-pressed', String(zoomed));
      if (button) button.textContent = zoomed ? '−' : '+';
      const content = this.querySelector('[role="document"]');
      requestAnimationFrame(() => content.scrollTo((content.scrollWidth - content.clientWidth) / 2, (content.scrollHeight - content.clientHeight) / 2));
    }
  });
}
